import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  documents: [],
  areDocumentsLoading: false,
  areDocumentsFetched: false,
  areDocumentsError: false,
};

const documentsSlice = createSlice({
  name: 'documents',
  initialState,
  reducers: {
    documentsReset(state) {
      state.documents = [];
      state.areDocumentsLoading = false;
      state.areDocumentssError = false;
      state.areDocumentsFetched = false;
    },
    documentsLoading(state) {
      state.areDocumentsLoading = true;
      state.areDocumentsError = false;
      state.areDocumentsFetched = false;
    },
    documentsSuccess(state, { payload }) {
      state.documents = payload;
      state.areDocumentsLoading = false;
      state.areDocumentsError = false;
      state.areDocumentsFetched = true;
    },
    documentsFailure(state) {
      state.areDocumentsLoading = false;
      state.areDocumentsError = true;
      state.areDocumentsFetched = false;
    },
  },
});

export const {
  documentsLoading,
  documentsSuccess,
  documentsFailure,
  documentsReset,
} = documentsSlice.actions;
export default documentsSlice.reducer;
